import { rem, useMantineTheme } from '@mantine/core';
import * as allIcons from '@sloyd/icons';

export type IconProps = {
  name: string;
  className?: string;
  color?: string;
  size?: number;
  onClick?: () => void;
};

export function Icon(props: IconProps) {
  const { name, color, size = 20 } = props;
  const theme = useMantineTheme();

  const Cmp = (allIcons as any)[name];

  if (!Cmp) return null;

  return (
    <Cmp
      {...props}
      style={{ width: rem(size), height: rem(size) }}
      stroke={1.5}
      color={color ?? theme.colors.pink[4]}
    />
  );
}

export default Icon;
